<static-hdr></static-hdr>

<section class="billboard">
  <div class="container h-100 d-flex align-items-center">

    <div>
      <h1 class="px-0 py-15 text-left">برنامج تمكين الجهات الحكومية في مجال كفاءة الطاقة​</h1>
      <div class="mt-8">
        <button [routerLink]="['/about']" class="btn btn-warning font-size-h1-lg px-8 mb-n8">إعرف أكثر</button>
        <!-- <button class="btn btn-warning font-size-h1-lg px-5"> <i class="fa fa-play"></i> </button> -->
      </div>
    </div>
  </div>

</section>



<section class="my-20">
  <!-- <div class="container">

    <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 justify-content-center">
      <div class="col text-center my-10 my-lg-0">
        <img src="/assets/common/images/lightbulb-on.png" alt="lightbulb-on" />
        <h2 class="my-5">الهدف</h2>
        <h4 class="text-black-50 line-height-lg px-md-15">يهدف البرنامج إلى تقليل حجم إستخدام الطاقة في الجهات الحكوميه بمختلف المباني</h4>
      </div>
      <div class="col text-center my-10 my-lg-0">
        <img src="/assets/common/images/desktop-alt.png" alt="desktop-alt" />
        <h2 class="my-5">التوعية</h2>
        <h4 class="text-black-50 line-height-lg px-md-15">يقدم البرنامج العديد من البرامج التوعويه والخطط التفاعليه وذلك لدعم الجهات في تقليل الإستهلاك</h4>
      </div>
      <div class="col text-center my-10 my-lg-0">
        <img src="/assets/common/images/phone-volume.png" alt="phone-volume" />
        <h2 class="my-5">الدعم</h2>
        <h4 class="text-black-50 line-height-lg px-md-15">نوفر العديد من قنوات الإتصال لنمكن الجميع من التواصل معنا بشكل ميسر وسهل</h4>
      </div>

    </div>

  </div> -->

  <h1 class="font-weight-bold display-4 text-primary my-8 text-center pb-6">الهدف</h1>

  <div class="goal-container">
    <div class="right-patt"></div>
    <div class="container skewed-box">
      <div class="goal-content">
        <img class="mb-10" src="/assets/common/images/idea.svg" alt="">
        <h1 class="goal-title">
          يهدف البرنامج إلى تمكين الجهات الحكومية من تنفيذ متطلبات الأوامر السامية الصادرة بشأن كفاءة الطاقة
        </h1>
      </div>
    </div>
    <div class="left-patt"></div>
  </div>

</section>



<!-- <section class="bgBoxLight py-10">
  <div class="container">

    <h1 class="font-weight-bold display-4 text-primary mb-10 text-center">الإنتاجات التوعوية</h1>

    <p-carousel [value]="cities" [numVisible]="4" [numScroll]="1" [showIndicators]="false" [responsiveOptions]="responsiveOptions" [autoplayInterval]="6000"
      styleClass="carouselSlider">
      <ng-template let-image pTemplate="item">
        <div class="shadow-sm">
          <img class="w-100" [src]="image.src" [alt]="image.alt" />
        </div>
      </ng-template>
    </p-carousel>

    <div class="text-center my-10">
      <a class="btn btn-primary showAll font-size-h2 px-8" href="">مشاهدة الكل</a>
    </div>

  </div>

</section> -->




<!-- <section class="my-25">
  <div class="container">
    <h1 class="font-weight-bold display-4 text-primary my-8">الدورات التدريبية</h1>
    <h2 class="line-height-lg text-black-50 mb-10">
      في إطار دعمنا للجهات الحكومية تم إعداد عدد من الدورات التدريبية المناسبة للجميع تهدف إلى
      <br class="d-none d-lg-block ">
      ترشيد إستهلاك الكهرباء والوقود
    </h2>

    <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 mt-12">
      <div class="col mb-8">
        <a href="javascript:void(0)" class="bgBoxLight d-block">

          <div class="courseR">
            <div class="showLink">سجل الآن</div>
            <img src="/assets/common/images/course01.png" class="course w-100" alt="course01" />
          </div>

          <div class="px-5 py-12">
            <h3 class="textLgreen">وقود المركبات</h3>
            <div class="mt-4 font-weight-bold d-flex justify-content-between">
              <span>6 ساعات</span>
              <span>Online</span>
              <span>22/12 - 23/12 2021</span>
            </div>
          </div>
        </a>
      </div>
      <div class="col mb-8">
        <a href="javascript:void(0)" class="bgBoxLight d-block">

          <div class="courseR">
            <div class="showLink">سجل الآن</div>
            <img src="/assets/common/images/course02.png" class="course w-100" alt="course01" />
          </div>

          <div class="px-5 py-12">
            <h3 class="textLgreen">ضوء الشمس في المكتب</h3>
            <div class="mt-4 font-weight-bold d-flex justify-content-between">
              <span>6 ساعات</span>
              <span>Online</span>
              <span>22/12 - 23/12 2021</span>
            </div>
          </div>
        </a>
      </div>
      <div class="col mb-8">
        <a href="javascript:void(0)" class="bgBoxLight d-block">

          <div class="courseR">
            <div class="showLink">سجل الآن</div>
            <img src="/assets/common/images/course03.png" class="course w-100" alt="course01" />
          </div>

          <div class="px-5 py-12">
            <h3 class="textLgreen">التكيف والإستهلاك</h3>
            <div class="mt-4 font-weight-bold d-flex justify-content-between">
              <span>6 ساعات</span>
              <span>Online</span>
              <span>22/12 - 23/12 2021</span>
            </div>
          </div>
        </a>
      </div>
      <div class="col mb-8">
        <a href="javascript:void(0)" class="bgBoxLight d-block">

          <div class="courseR">
            <div class="showLink">سجل الآن</div>
            <img src="/assets/common/images/course04.png" class="course w-100" alt="course01" />
          </div>

          <div class="px-5 py-12">
            <h3 class="textLgreen">إرشادات الإستهلاك</h3>
            <div class="mt-4 font-weight-bold d-flex justify-content-between">
              <span>6 ساعات</span>
              <span>Online</span>
              <span>22/12 - 23/12 2021</span>
            </div>
          </div>
        </a>
      </div>


    </div>

    <div class="text-center">
      <a class="btn btn-primary showAll font-size-h2 px-8" href="">{{l('ShowAll')}}</a>
    </div>

  </div>
</section> -->


<section class="my-25">
  <div class="container">
    <h1 class="font-weight-bold display-4 text-primary my-8">{{l('News')}}</h1>
    <!--  <p-carousel #news [showNavigators]="false" [value]="newsList" [numVisible]="3">
            <ng-template let-newsView pTemplate="item">
                <ImportantNews [newsitemView]="newsView">

                </ImportantNews>
            </ng-template>
        </p-carousel> -->
    <div class="row my-10">
      <div *ngFor="let newsView of newsList" class="col-md-4 mb-4">
        <ImportantNews [newsitemView]="newsView">

        </ImportantNews>
      </div>


    </div>
  </div>

  <div class="text-center">
    <a class="btn btn-primary showAll font-size-h2 px-8" href="" [routerLink]="['/media-center/news']">{{l('ShowAll')}}</a>
  </div>
</section>



<section>
  <div class="container">
    <h1 class="font-weight-bold display-4 text-primary my-8">الأسئلة الشائعة</h1>
  </div>

  <div class="bgBoxLight">
    <div class="container d-flex align-items-center">
      <p-accordion class="flex-grow-1" styleClass="faq py-10">
        <p-accordionTab *ngFor="let item of faqcategories" header="{{item.faqCategory.categoryName}}">
          <faq-item [categoryId]="item.faqCategory.id"></faq-item>
        </p-accordionTab>
        <!--  <p-accordionTab header="هل الدورات التدريبية مجانية ام يوجد عليها رسوم ؟">
          هل الدورات التدريبية مجانية ام يوجد عليها رسوم هل الدورات التدريبية مجانية ام يوجد عليها رسوم
        </p-accordionTab>
        <p-accordionTab header="كيف يمكننا الاشتراك بالحملات التوعوية الخاصة بالمبادرة ؟">
          كيف يمكننا الاشتراك بالحملات التوعوية الخاصة بالمبادرة كيف يمكننا الاشتراك بالحملات التوعوية الخاصة بالمبادرة
        </p-accordionTab> -->
      </p-accordion>

      <div class="bg-white mb-n12 mt-n12 p-7 shadow d-none d-lg-block ">
        <img class="faqImg" src="/assets/common/images/faq.png" alt="faq" />
      </div>

    </div>
  </div>

  <div class="container my-10">
    <a class="btn btn-primary showAll font-size-h2 px-8" href="" [routerLink]="['/faq']">{{l('ShowAll')}}</a>
  </div>
</section>


<static-ftr></static-ftr>